'use strict'

define ['./applicantAppbundlesTable.css'], () ->
  ($rootScope, RentappService, ApplicationBundle, $state, $http, RENTAPPLICATION_API_URL, $timeout, $cacheFactory) ->
    restrict: "E"
    template: require("./applicantAppbundlesTable.jade")
    scope:
      displayed: "="
    link: (scope, element, attrs) ->
      RentappService.getMe().then (user) ->
        scope.applicant_username = user.username

      scope.is_loading = false

      scope.search_term = ""

      scope.status_class_map =
        'I': 'sent-to-applicant'
        'P': 'partial'
        'S': 'submitted'
        'R': 'rejected'
        'A': 'accepted'

      $rootScope.$on 'refresh-applicant-appbundle-table', (event, data) ->
        scope.load_table()

      scope.view_app = (app) ->
        $state.go "root.dashboard.view_application", { application_id: app.id }

      scope.edit_app = (app) ->
        $state.go "root.applications.edit", { application_id: app.id }

      scope.load_table = () ->
        scope.is_loading = true
        $cacheFactory.get("$http").removeAll()

        ApplicationBundle.query
          limit: 25
          offset: 0
          for_datatable: true
          applications__applicant__user__username: scope.applicant_username
        .$promise.then (appbundles) ->
          scope.displayed = appbundles.objects
          scope.is_loading = false

      scope.reset = () ->
        scope.search_term = ''

      scope.search = (search_term) ->
        scope.is_loading = true
        $cacheFactory.get("$http").removeAll()

        ApplicationBundle.query
          limit: 25
          offset: 0
          for_datatable: true
          search: search_term.trim()
          applications__applicant__user__username: scope.applicant_username
        .$promise.then (appbundles) ->
          scope.displayed = appbundles.objects
          scope.is_loading = false

      scope.formatDate = (date) =>
        new Date(date)

      scope.$on 'paginate', (event, data) ->
        ApplicationBundle.query
          limit: 25
          offset: (data.page - 1) * 25
          applications__applicant__user__username: scope.applicant_username
          for_datatable: true
          search: scope.search_term.trim()
        .$promise.then (appbundles) ->
          scope.displayed = appbundles.objects
          scope.is_loading = false



// WEBPACK FOOTER //
// ./directives/applicantAppbundlesTable/applicantAppbundlesTable.coffee